import SiteHeaderMobile from "@/components/site-header-mobile";
import SiteMegamenu from "@/components/site-megamenu";
import ModalEmbedded from "@/components/modal-embeded";
import ModalLeaflet from "@/components/modal-leaflet";
import ModalContact from "@/components/modal-contact";
import { Anchor } from "@/components/anchor";
import { Hero } from "@/components/hero";
import { Sticky } from "@/components/sticky";
import { LazyloadMedia } from "@/components/lazyload-media";
import { FormFileUpload, FormSelect, FormFloat } from "@/components/form/elements";
import { FormContact } from '@/components/form/form-contact';
import { FormSubscribe } from '@/components/form/form-subscribe';
import { FormLeaflet } from '@/components/form/form-leaflet';
import Album from "@/components/albums";
import AlbumGeneral from "@/components/album-general";
import SwiperCarousel from "@/components/swiper-carousel";
import SwiperThumb from "@/components/swiper-thumb";
import Job from "@/components/job";
import Location from "@/components/location";
import Classify from "@/components/classify";
import { Timeline } from "@/components/solution-overview";
import { Gallery } from "@/components/gallery";
import { RichText } from '@/components/richtext';
import CookieConsent from "@/components/cookie-consent";
import { FeaturedPopup } from '@/components/featured-popup';
import { PageHome } from '@/pages/page-home';
import 'jquery-match-height';
import { VideoAutoplay } from "./components/video-autoplay";
SiteHeaderMobile.init();
SiteMegamenu.init();
ModalEmbedded.init();
ModalLeaflet.init();
ModalContact.init();
Album.init();
AlbumGeneral.init();
SwiperCarousel.init();
SwiperThumb.init();
Job.init();
Location.init();
Classify.init();
CookieConsent.init();
new FormSelect();
new FormFileUpload();
new FormFloat();
new FormContact();
new FormLeaflet();
new FormSubscribe();
new LazyloadMedia();
new Anchor();
new Hero();
new Sticky();
new Gallery();
new RichText();
new FeaturedPopup();
new Timeline();
new PageHome();
new VideoAutoplay();
